import {
  useEffect,
  useState,
} from "react";

import {
  Button,
  Col,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";

import {
  getItLaitteet,
  createItLaite,
  updateItLaite,
  deleteItLaite,
} from "../../api/api";

const EMPTY_IT_DEVICE = {
  id: null,
  laitetyyppi: "",
  merkki_malli: "",
  hankintapaiva: "",
  leasing: false,
  leasing_paattymispaiva: "",
};

export default function ItDeviceManager({
  userId,
  showToast,
}) {
  const [
    devices,
    setDevices,
  ] = useState([]);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    editingDevice,
    setEditingDevice,
  ] = useState(null);

  const [
    saving,
    setSaving,
  ] = useState(false);

  const loadDevices =
    async () => {
      if (!userId) return;

      try {
        setLoading(true);

        const data =
          await getItLaitteet(
            userId
          );

        setDevices(
          Array.isArray(data)
            ? data
            : []
        );
      } catch (error) {
        console.error(
          "❌ IT-laitteiden lataus epäonnistui:",
          error
        );

        showToast?.(
          "❌ IT-laitteiden lataus epäonnistui",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    loadDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const handleAdd = () => {
    setEditingDevice({
      ...EMPTY_IT_DEVICE,
    });
  };

  const handleEdit = (
    device
  ) => {
    setEditingDevice({
      ...EMPTY_IT_DEVICE,
      ...device,

      hankintapaiva:
        device.hankintapaiva
          ? String(
              device.hankintapaiva
            ).slice(0, 10)
          : "",

      leasing_paattymispaiva:
        device.leasing_paattymispaiva
          ? String(
              device.leasing_paattymispaiva
            ).slice(0, 10)
          : "",
    });
  };

  const changeDevice = (
    field,
    value
  ) => {
    setEditingDevice(
      (previous) => ({
        ...previous,
        [field]: value,
      })
    );
  };

  const handleSave =
    async () => {
      if (
        !editingDevice?.laitetyyppi
      ) {
        showToast?.(
          "Valitse laitetyyppi",
          "danger"
        );

        return;
      }

      if (
        !editingDevice?.merkki_malli?.trim()
      ) {
        showToast?.(
          "Merkki ja malli vaaditaan",
          "danger"
        );

        return;
      }

      try {
        setSaving(true);

        const payload = {
          laitetyyppi:
            editingDevice.laitetyyppi,

          merkki_malli:
            editingDevice.merkki_malli.trim(),

          hankintapaiva:
            editingDevice.hankintapaiva ||
            null,

          leasing:
            Boolean(
              editingDevice.leasing
            ),

          leasing_paattymispaiva:
            editingDevice.leasing
              ? editingDevice.leasing_paattymispaiva ||
                null
              : null,
        };

        if (
          editingDevice.id
        ) {
          await updateItLaite(
            editingDevice.id,
            payload
          );
        } else {
          await createItLaite(
            userId,
            payload
          );
        }

        await loadDevices();

        setEditingDevice(null);

        showToast?.(
          editingDevice.id
            ? "✅ IT-laitteen tiedot päivitetty"
            : "✅ IT-laite lisätty",
          "success"
        );
      } catch (error) {
        console.error(
          "❌ IT-laitteen tallennus epäonnistui:",
          error
        );

        showToast?.(
          "❌ IT-laitteen tallennus epäonnistui",
          "danger"
        );
      } finally {
        setSaving(false);
      }
    };

  const handleDelete =
    async (device) => {
      if (
        !window.confirm(
          `Haluatko varmasti poistaa laitteen "${device.merkki_malli}"?`
        )
      ) {
        return;
      }

      try {
        await deleteItLaite(
          device.id
        );

        setDevices(
          (previous) =>
            previous.filter(
              (item) =>
                item.id !==
                device.id
            )
        );

        if (
          editingDevice?.id ===
          device.id
        ) {
          setEditingDevice(
            null
          );
        }

        showToast?.(
          "✅ IT-laite poistettu",
          "success"
        );
      } catch (error) {
        console.error(
          "❌ IT-laitteen poisto epäonnistui:",
          error
        );

        showToast?.(
          "❌ IT-laitteen poisto epäonnistui",
          "danger"
        );
      }
    };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5
            className="mb-1"
            style={{
              color: "#264d26",
            }}
          >
            IT-laitteet
          </h5>

          <div className="text-muted small">
            Käyttäjän IT-laitteet.
          </div>
        </div>

        <Button
          type="button"
          size="sm"
          onClick={handleAdd}
          style={{
            backgroundColor:
              "#04aa00",
            borderColor:
              "#04aa00",
          }}
        >
          + Lisää IT-laite
        </Button>
      </div>

      {loading ? (
        <div className="text-center py-4">
          <Spinner
            animation="border"
            size="sm"
          />
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
  {devices.map((device, index) => {
    const isEditing =
      editingDevice?.id === device.id;

    return (
      <div
        key={device.id || `it-device-${index}`}
        style={{
          border: "1px solid #e3e9e3",
          borderLeft: "5px solid #04aa00",
          borderRadius: "12px",
          backgroundColor: "#ffffff",
          boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
          overflow: "hidden",
        }}
      >
        {/* HEADER */}
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            padding: "12px 16px",
            backgroundColor: "#f7fbf7",
            borderBottom: "1px solid #e7ece7",
          }}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "#04aa00",
                color: "#ffffff",
                fontWeight: "700",
                fontSize: "13px",
                flexShrink: 0,
              }}
            >
              {index + 1}
            </div>

            <div>
              <div
                className="fw-semibold"
                style={{
                  color: "#315b31",
                }}
              >
                {device.merkki_malli || "IT-laite"}
              </div>

              <div
                className="text-muted"
                style={{
                  fontSize: "12px",
                }}
              >
                {device.laitetyyppi || "Laitetyyppiä ei määritetty"}
              </div>
            </div>
          </div>

          <div className="d-flex gap-2">
            <Button
              type="button"
              size="sm"
              variant="outline-secondary"
              style={
                isEditing
                  ? {
                      backgroundColor: "#04aa00",
                      borderColor: "#04aa00",
                      color: "#ffffff",
                    }
                  : {}
              }
              onClick={() => {
                if (isEditing) {
                  setEditingDevice(null);
                } else {
                  handleEdit(device);
                }
              }}
            >
              {isEditing ? "Valmis" : "Muokkaa"}
            </Button>

            <Button
              type="button"
              size="sm"
              variant="outline-danger"
              onClick={() => handleDelete(device)}
            >
              Poista
            </Button>
          </div>
        </div>

        {/* READ ONLY */}
        {!isEditing && (
          <div style={{ padding: "16px" }}>
            <Row className="g-3">
              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Laitetyyppi
                </div>

                <div>
                  {device.laitetyyppi || "–"}
                </div>
              </Col>

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Merkki ja malli
                </div>

                <div>
                  {device.merkki_malli || "–"}
                </div>
              </Col>

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Hankintapäivä
                </div>

                <div>
                  {device.hankintapaiva
                    ? String(device.hankintapaiva).slice(0, 10)
                    : "–"}
                </div>
              </Col>

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Leasing
                </div>

                <div>
                  {device.leasing ? "Kyllä" : "Ei"}
                </div>
              </Col>

              {device.leasing && (
                <Col md={4}>
                  <div
                    className="text-muted fw-semibold"
                    style={{ fontSize: "12px" }}
                  >
                    Leasing päättyy
                  </div>

                  <div>
                    {device.leasing_paattymispaiva
                      ? String(
                          device.leasing_paattymispaiva
                        ).slice(0, 10)
                      : "–"}
                  </div>
                </Col>
              )}
            </Row>
          </div>
        )}

        {/* EDIT MODE */}
        {isEditing && (
          <div style={{ padding: "16px" }}>
            <Row className="g-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold small">
                    Laitetyyppi
                  </Form.Label>

                  <Form.Select
                    value={editingDevice.laitetyyppi || ""}
                    onChange={(e) =>
                      changeDevice(
                        "laitetyyppi",
                        e.target.value
                      )
                    }
                    style={{
                      borderRadius: "8px",
                    }}
                  >
                    <option value="">
                      Valitse
                    </option>

                    <option value="Kannettava tietokone">
                      Kannettava tietokone
                    </option>

                    <option value="Pöytätietokone">
                      Pöytätietokone
                    </option>

                    <option value="Puhelin">
                      Puhelin
                    </option>

                    <option value="Tabletti">
                      Tabletti
                    </option>

                    <option value="Näyttö">
                      Näyttö
                    </option>

                    <option value="Muu">
                      Muu
                    </option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold small">
                    Merkki ja malli
                  </Form.Label>

                  <Form.Control
                    value={editingDevice.merkki_malli || ""}
                    onChange={(e) =>
                      changeDevice(
                        "merkki_malli",
                        e.target.value
                      )
                    }
                    style={{
                      borderRadius: "8px",
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold small">
                    Hankintapäivä
                  </Form.Label>

                  <Form.Control
                    type="date"
                    value={editingDevice.hankintapaiva || ""}
                    onChange={(e) =>
                      changeDevice(
                        "hankintapaiva",
                        e.target.value
                      )
                    }
                    style={{
                      borderRadius: "8px",
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Check
                  className="mt-4"
                  type="switch"
                  label="Leasing"
                  checked={Boolean(editingDevice.leasing)}
                  onChange={(e) =>
                    changeDevice(
                      "leasing",
                      e.target.checked
                    )
                  }
                />
              </Col>

              {editingDevice.leasing && (
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-semibold small">
                      Leasing päättyy
                    </Form.Label>

                    <Form.Control
                      type="date"
                      value={
                        editingDevice.leasing_paattymispaiva || ""
                      }
                      onChange={(e) =>
                        changeDevice(
                          "leasing_paattymispaiva",
                          e.target.value
                        )
                      }
                      style={{
                        borderRadius: "8px",
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>

            <div className="d-flex gap-2 mt-4">
              <Button
                type="button"
                disabled={saving}
                onClick={handleSave}
                style={{
                  backgroundColor: "#04aa00",
                  borderColor: "#04aa00",
                  borderRadius: "8px",
                }}
              >
                {saving
                  ? "Tallennetaan..."
                  : "Tallenna"}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  })}
</div>
      )}
    </>
  );
}